<template>
  <v-main>
    <v-sheet class="mx-auto">
      <v-slide-group v-model="slideModel" center-active show-arrows>
        <v-slide-item
          v-for="(article,artKey) in getArticles"
          :key="artKey+Math.random()+Math.random()"
          v-slot="{ toggle }"
        >
          <v-card height="400" width="450" @click="toggle">
            <v-row class="fill-height" align="center" justify="center">
              <v-scale-transition>
                <v-card class="mx-auto" width="400" shaped>
                  <v-img
                    class="white--text align-end"
                    height="200px"
                    lazy-src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"
                  >
                    <v-card-title>{{article.title}}</v-card-title>
                  </v-img>

                  <v-card-subtitle class="pb-0">{{article.date_posted}}</v-card-subtitle>

                  <v-card-text class="text--primary">
                    <div>{{article.name}}</div>

                    <div v-html="article.body.substring(0, 100) + ' ....'" class="py-2"></div>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn :color="getThemeColor" text @click="readPost(article)">Read More</v-btn>
                  </v-card-actions>
                </v-card>
              </v-scale-transition>
            </v-row>
          </v-card>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
  </v-main>
</template>

<script>
export default {
  computed: {
    getArticles() {
      return this.$store.getters.getArticles;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    }
  },
  data: () => ({
    slideModel: null,
    articleModel: 1,
    articles: []
  }),
  methods: {
    readPost(post) {
      this.$router.push({ name: "read-post", params: { post } });
    }
  }
};
</script>

<style>
</style>